var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_578_16",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_578_16",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADCUlEQVR4nO2Zv2sUQRTHFwtN4o9cE7EwmKTSTgsjEv8AowYSYStNo4g/sFJjF1CIpQmWgkaLgP9BSFJb6EVjIQrRxkgiWmks9MTARx68Cy/D3Gb37ja7yH7g4JjvzLz97uzMvNkNgoKCgoL/CqAV6APCjH59cg2NmjgGLJE9n4DeRkYiDyasmZZ6jJwgf/TVY0Sez3WCjGAjYT0dFEaaCcWIKMWjlfdHi+x29qYbyQNhYSRnhMWIxGQZmAEqHq0MzHvKK9pmOUF/YZojIkHbtc0pR3ts+pt0tJNa3g6sxOwvTNPIjGkjF2W5YLSLjrbHaLMx+wvTNFLROydBHzjaAtAN9ABvHG1CzACngT8x+wvTNLKVhIWRnDHcjBF5LZPXs/oIj1STOWFZBW4BI/q/UX4D94DtjRjpMprdF8qmXCa2ZcRot2keL4F99RrpNtorUz5vynsaMPIVGNNXUHvlrgP7gUFgCvjr1H8PdNRjZEH3gieei5hUzV1iV9WA/H5GmBgHdpnYB4AB+/oHOKRZgmUO2JbUSFpcceJ2GtOznndt0077S3kwMu6Je9boax5dNtFFU2clcvJvgZFvwO7N4gb+azvj9DWUxMh9vRv9TlYq/0+qJmmHu2R36c9dmsfixA1qX98HU20yiZF6kryopPF4g0YmTLV3SYz0a3kpIu2WBBDfnQKeOlpHzLilGvWumTrfkxip6EhYE1VWVLNZbJV5Z9+psiNm3LLPDHDeXlsSI82ms0bckme/kJvR5tS7afSlKCPypShNBiNilzxmLjt1nhnteZSRVv24khZTNYMH62ZsTjdgtJ3AD6PdiepLGvSmaEZyp4ObxG8DrloTWj7q9HU40og2amnix9BhTcWrlJN+6ASOAr9MH3NBFuh5wjJt96gYJr6YtmvAkSALND1/4ZhZdB8fi86JUWckNhwTMkEORbIbe+bNR03prwPngBu6OtmJXeVhkAdkZ9fzRFLWMh8JFzkUyXmiRraABzGezZyIg86bIT19vtVHSdKdz7LZAXc3W2L/ASVU9XM96CdnAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSchedule);
export default __webpack_public_path__ + "static/media/whiteSchedule.3f528b86d8360fee1da1cc5170f38a5d.svg";
export { ForwardRef as ReactComponent };